// extracted by mini-css-extract-plugin
var _1 = "WidgetContentItemsList-moduleWidgetContentItemsList__O81l8";
var _2 = "WidgetContentItemsList-modulecontentWrapper__y5EEv";
var _3 = "WidgetContentItemsList-moduleemptyState__tRrcI";
var _4 = "WidgetContentItemsList-modulefooter__m6aDz";
var _5 = "WidgetContentItemsList-moduleinfoIcon__yPoNn IconNG-moduleiconContainer__SxWZ0";
var _6 = "WidgetContentItemsList-moduleitemsContainer__QKSlj";
var _7 = "WidgetContentItemsList-moduleitemsContainerLoadingMore__Lr2yi";
var _8 = "WidgetContentItemsList-moduleloader__LfkMU";
var _9 = "WidgetContentItemsList-modulescrollContainer__oHD2X ScrollContainer-moduleScrollContainer__LHyVB";
var _a = "WidgetContentItemsList-moduleshadow__ayy84 useContentEdgesShadow-moduleshadow__AV8Z4";
var _b = "WidgetContentItemsList-moduletitle__mUHAc";
var _c = "WidgetContentItemsList-moduletitleEndContent__qSfbm";
var _d = "WidgetContentItemsList-moduletitleWrapper__Wdg5G";
export { _1 as "WidgetContentItemsList", _2 as "contentWrapper", _3 as "emptyState", _4 as "footer", _5 as "infoIcon", _6 as "itemsContainer", _7 as "itemsContainerLoadingMore", _8 as "loader", _9 as "scrollContainer", _a as "shadow", _b as "title", _c as "titleEndContent", _d as "titleWrapper" }
